import ModalCompetitorsEdit from "./ModalCompetitorsEdit";
import ModalCompetitorsLayout from "./ModalCompetitorsLayout";
import ModalCompetitorsPreview from "./ModalCompetitorsPreview";
import ModalCreateContentFolder from "../../ModalCreateContentFolder";
import ModalMoveContentsToFolder from "../../ModalMoveContentsToFolder";
import ModalRenameContentFolder from "../../ModalRenameContentFolder";

const ModalCompetitorsView = ({
  layoutProps,
  filtersProps,
  galleryProps,
  previewProps,
  editorProps,
  folderModalsProps = {},
}) => (
  <>
    <ModalCompetitorsLayout
      {...layoutProps}
      filtersProps={filtersProps}
      galleryProps={galleryProps}
    />

    <ModalCompetitorsEdit {...editorProps} />

    <ModalCompetitorsPreview {...previewProps} />

    <ModalCreateContentFolder
      modalOpen={folderModalsProps.isOpenCreateFolderModal}
      folders={folderModalsProps.folders}
      parentFolderID={folderModalsProps.createFolderParentID}
      parentFolderLabel={folderModalsProps.createFolderParentLabel}
      isLoading={folderModalsProps.isCreatingFolder}
      onCloseModal={folderModalsProps.closeCreateFolderModal}
      onCallbackCreate={folderModalsProps.onCreateFolderInContext}
    />
    <ModalMoveContentsToFolder
      modalOpen={folderModalsProps.isOpenMoveFolderModal}
      folders={folderModalsProps.folders}
      currentFolderLabel={folderModalsProps.currentFolderLabelForMove}
      createParentFolderID={folderModalsProps.createFolderParentID}
      createParentFolderLabel={folderModalsProps.createFolderParentLabel}
      disabledFolderID={folderModalsProps.disabledMoveFolderID}
      isLoading={folderModalsProps.isMovingContents}
      isCreatingFolder={folderModalsProps.isCreatingFolder}
      onCloseModal={folderModalsProps.closeMoveFolderModal}
      onCallbackCreate={folderModalsProps.onCreateFolderInContext}
      onCallbackMove={folderModalsProps.onCallbackMoveToFolder}
      showResultAlerts={folderModalsProps.showMoveResultAlerts}
      titleKey={folderModalsProps.moveModalTitleKey}
      primaryButtonTextKey={folderModalsProps.moveModalPrimaryButtonKey}
      showMoveDescription={folderModalsProps.showMoveDescription}
    />
    <ModalRenameContentFolder
      modalOpen={folderModalsProps.isOpenRenameFolderModal}
      folders={folderModalsProps.folders}
      folder={folderModalsProps.renameFolderTarget}
      isLoading={folderModalsProps.isRenamingFolder}
      onCloseModal={folderModalsProps.closeRenameFolderModal}
      onCallbackRename={folderModalsProps.onRenameFolder}
    />
  </>
);

export default ModalCompetitorsView;
